export default __webpack_public_path__ + "static/media/B0000.87f8006f.png";